import { createPortal } from "react-dom";
import { X, Trash2 } from "lucide-react";

const modalRoot = typeof window !== "undefined" ? document.getElementById("modal-root") : null;

export default function DeleteModal({ onClose, onConfirm, title = "Are you sure you want to delete this?", subtitle = "This action cannot be undone." }) {
  if (!modalRoot) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 relative">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-red-500">
          <X size={20} />
        </button>

        {/* Icon and Text */}
        <div className="flex flex-col items-center text-center">
          <Trash2 className="w-10 h-10 text-red-500 mb-3" />
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
        </div>

        {/* Actions */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 text-sm"
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    modalRoot
  );
}